<div class="welcome-modal-wrapper">

    <div class="modal-header">
        <span class="modal-title" translate="cart.first.time.modal.title"></span>
    </div>

    <div class="modal-body" id="modal-body">
        <div>{{displayText}}</div>
        <br>
        <span *ngIf="!!displayText" class="modal-title" translate="cart.some.exclusions.apply"></span>
    </div>
    <div class="modal-footer">
        <button class="btn btn-primary" type="button" (click)="cancel()" translate="cart.confirm.ok"></button>
    </div>
</div>


